import React, {useEffect, useState} from 'react';
import {FormattedMessage, useIntl} from 'react-intl';
import {StyledFieldInput} from '../../../_common/components/FieldInput';
import {StyledFieldSelect} from '../../../_common/components/FieldSelect';
import {filterOptions} from '../../../_common/utils/options';
import {buttonCancel, buttonSubmit, largeButtonsPadding} from '../../../_common/styles/styles';
import ModalHeader from '../../../_common/components/ModalHeader';
import ModalContent from '../../../_common/components/ModalContent';
import ModalButtonsContainer from '../../../_common/components/ModalButtonsContainer';
import ButtonAction from '../../../_common/components/ButtonAction';
import {integerValueCanStartFromNull} from '../../../_common/utils/changeInputValue';
import * as generalActions from '../../../_common/actions/generalData';
import styles from './styles.module.scss';

export default function ContactForm({
                                      onSubmit,
                                      values,
                                      setFieldValue,
                                      errors,
                                      isValid,
                                      dirty,
                                      handleCloseModal
                                    }) {
  const intl = useIntl();
  const prefix = 'contacts-popup';
  const commonProps = {customLabelStyles: 'font-weight-bolder', customContainerStyles: 'py-3'};

  const [contactStatusTypes, setContactStatusTypes] = useState([]);
  useEffect(() => {
    generalActions.getContactStatusTypes()
      .then(setContactStatusTypes)
      .catch((e) => {
        console.error(e);
        setContactStatusTypes([]);
      });
  }, []);
  const name = [values?.firstName, values?.lastName].filter(Boolean).join(' ');
  const header = values.contactID === -1
    ? <FormattedMessage id={`contacts-popup-header-create`} defaultMessage="Add contact?"/>
    : <FormattedMessage id={`contacts-popup-header-edit`} defaultMessage="Edit contact {name}" values={{name}}/>;

  return (
    <div>
      <ModalHeader header={header}/>
      <ModalContent customClassnames={'bg-transparent'}>
        <div className={'d-flex justify-content-between'}>
          <div className={'w-100 mr-4'}>
            <StyledFieldInput
              fieldId={'firstName'}
              value={values.firstName}
              label={
                <div>
                  <span>{intl.formatMessage({id: `${prefix}-firstName`, defaultMessage: 'First name'})}</span>
                  <span className={'text-danger'}>*</span>
                </div>
              }
              onChange={(e) => setFieldValue('firstName', e.target.value)}
              icon={'/media/common/User_primary.svg'}
              {...commonProps}
            />
            <StyledFieldInput
              fieldId={'lastName'}
              value={values.lastName}
              label={
                <div>
                  <span>{intl.formatMessage({id: `${prefix}-lastName`, defaultMessage: 'Last name'})}</span>
                  <span className={'text-danger'}>*</span>
                </div>
              }
              onChange={(e) => setFieldValue('lastName', e.target.value)}
              icon={'/media/common/User_primary.svg'}
              {...commonProps}
            />
            <div className={'position-relative'}>
              <StyledFieldInput
                fieldId={'phone'}
                value={values.phone}
                label={
                  <div>
                    <span>{intl.formatMessage({id: `${prefix}-phone`, defaultMessage: 'Phone'})}</span>
                    <span className={'text-danger'}>*</span>
                  </div>
                }
                onChange={(e) => setFieldValue('phone', integerValueCanStartFromNull(e))}
                icon={'/media/common/Phone_primary.svg'}
                {...commonProps}
              />
              {errors?.isPhoneAlreadyExists && (
                <div className={styles.invalidFieldValueMessage}>
                  {intl.formatMessage({
                    id: 'contacts-message-phoneExists',
                    defaultMessage: 'A phone number already exists for a contact'
                  })}
                </div>
              )}
            </div>
            <div className={'position-relative'}>
              <StyledFieldInput
                dir={'ltr'}
                fieldId={'email'}
                value={values.email}
                type={'email'}
                label={intl.formatMessage({id: `${prefix}-email`, defaultMessage: 'Email'})}
                customInputStyles={'text-left'}
                onChange={(e) => setFieldValue('email', e.target.value)}
                icon={'/media/common/Email_primary.svg'}
                {...commonProps}
              />
              {errors?.email && (
                <div className={styles.invalidFieldValueMessage}>
                  {intl.formatMessage({id: 'invalid-email-message', defaultMessage: 'Invalid email'})}
                </div>
              )}
              {errors?.isEmailAlreadyExists && (
                <div className={styles.invalidFieldValueMessage}>
                  {intl.formatMessage({
                    id: 'contacts-message-emailExists',
                    defaultMessage: 'The email address already exists for a contact'
                  })}
                </div>
              )}
            </div>
          </div>
          <div className={'w-100 ml-4'}>
            <StyledFieldInput
              fieldId={'job'}
              value={values.job}
              label={intl.formatMessage({id: `${prefix}-job`, defaultMessage: 'Job'})}
              onChange={(e) => setFieldValue('job', e.target.value)}
              icon={'/media/common/Order_primary.svg'}
              {...commonProps}
            />
            <StyledFieldInput
              fieldId={'organization'}
              value={values.organization}
              label={intl.formatMessage({id: `${prefix}-organization`, defaultMessage: 'Organization'})}
              onChange={(e) => setFieldValue('organization', e.target.value)}
              icon={'/media/common/Home_primary.svg'}
              {...commonProps}
            />
            <StyledFieldInput
              fieldId={'address'}
              value={values.address}
              label={intl.formatMessage({id: `${prefix}-address`, defaultMessage: 'Address'})}
              onChange={(e) => setFieldValue('address', e.target.value)}
              icon={'/media/common/Address_primary.svg'}
              {...commonProps}
            />
            <StyledFieldSelect
              fieldId={'statusID'}
              value={filterOptions(values.statusID)(contactStatusTypes)}
              options={contactStatusTypes}
              label={intl.formatMessage({id: `${prefix}-statusID`, defaultMessage: 'Status'})}
              onChange={(option) => setFieldValue('statusID', option.value)}
              {...commonProps}
            />
          </div>
        </div>
      </ModalContent>
      <ModalButtonsContainer customClassnames={largeButtonsPadding}>
        <ButtonAction
          variant={'cancel'}
          onClick={() => handleCloseModal()}
          label={intl.formatMessage({id: 'button-close', defaultMessage: 'Close'})}
          customClassnames={buttonCancel}
        />
        <ButtonAction
          onClick={async () => {
            await onSubmit();
            handleCloseModal();
          }}
          disabled={!isValid || !dirty}
          useIcon={'/media/common/Check-in-circle_white.svg'}
          label={intl.formatMessage({id: 'button-submit', defaultMessage: 'Submit'})}
          customClassnames={buttonSubmit}
        />
      </ModalButtonsContainer>
    </div>
  );
}
